export enum EventProperties {
    REFERENCE_MODEL_NAME = "referenceModelName",
    AMOUNT = "amount",
    PAGE_NAME = "pageName",
    COUPON_TYPE = "couponType",
    COUPON_AMOUNT = "couponAmount"
}
